<loading-bar [label]="'Creating asset'" *ngIf="saving"></loading-bar>

<div class="container" *ngIf="!saving">
    <h2>Create Asset</h2>
    <form #assetForm="ngForm" (ngSubmit)="onSubmit()">
        <div class="two-columns-layout">
            <div class="column-one form-column">
                <mat-form-field matTooltip="Product Classification ID from ABB Products" class="form-group" appearance="outline">
                    <mat-label for="cid">CID</mat-label>
                    <input matInput type="text" id="cid" name="cid" [(ngModel)]="createAssetCommand.cid" required>
                </mat-form-field>

                <mat-form-field matTooltip="Serial Number of the asset. Note: the serial number may not be unique for all products" class="form-group" appearance="outline">
                    <mat-label for="serialNumber">Serial Number</mat-label>
                    <input required matInput type="text" id="serialNumber" name="serialNumber"
                        [(ngModel)]="createAssetCommand.serialNumber">
                </mat-form-field>
            </div>  

            <div class="column-two">
                <mat-form-field matTooltip="Type code with possible option codes" class="form-group" appearance="outline">
                    <mat-label for="typeDesignation">Type Code</mat-label>
                    <input matInput type="text" id="typeDesignation" name="typeDesignation" [(ngModel)]="createAssetCommand.typeDesignation" required>
                </mat-form-field>

                <mat-form-field matTooltip="Type of Motion Device" class="form-group" appearance="outline">
                    <mat-label for="deviceType">Device Type</mat-label>
                    <mat-select id="deviceType" name="deviceType" [(ngModel)]="createAssetCommand.deviceType" required>
                        <mat-option *ngFor="let type of deviceTypes" [value]="type">{{ type }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>            
        </div>

        <p *ngIf="error" class="error">
            Error: {{ error }}
        </p>

        <div class="button-bar">
            <button mat-raised-button color="primary" type="submit" [disabled]="!assetForm.valid">Create Asset</button>
        </div>
    </form>
</div>